import type { ReactNode } from 'react';
import Script from 'next/script';
import { useEsusu } from '../contexts/EsusuContext';

interface EsusuLayoutProps {
  children: ReactNode;
}

export default function EsusuLayout({ children }: EsusuLayoutProps) {
  const { setIsEsusuScriptLoaded } = useEsusu();

  const handleEsusuLoad = () => {
    setIsEsusuScriptLoaded(true);
  };

  return (
    <>
      <Script src="https://sdk.esusu.io/latest/sdk.min.js" onLoad={handleEsusuLoad} />
      {children}
    </>
  );
}
